import ValorisationStocksFiltres from './valorisation.stocks.filtres.model';

export default class ValorisationStocksController {
	static $inject = [
		'$scope',
		'$translate',
		'ModalService',
		'StocksService',
		'StocksCloturesService',
		'localStorageService',
		'MassiaAuthService',
		'notification',
		'_',
		'moment',
		'$uibModal'
	];
	constructor(
		$scope,
		$translate,
		ModalService,
		StocksService,
		StocksCloturesService,
		localStorageService,
		MassiaAuthService,
		notification,
		_,
		moment,
		$uibModal
	) {
		this.$scope = $scope;
		this.$translate = $translate;
		this.ModalService = ModalService;
		this.StocksService = StocksService;
		this.StocksCloturesService = StocksCloturesService;
		this.localStorageService = localStorageService;
		this.MassiaAuthService = MassiaAuthService;
		this.notification = notification;
		this.moment = moment;
		this._ = _;
		this.$uibModal = $uibModal;
		this.valorisationStocksFiltres = {};
		this.typeAnalyseDemande = '';
		this.societes = [];
		this.regroupementsSite = [];
		this.grpSite = undefined;
		this.clotures = [];
		this.debutPeriodes = [];
		this.finPeriodes = [];
		this.finPeriodesDiplay = [];
		this.libPeriodeCloture = '';
		this.estSaisiePossible = false;
		this.controls = [];
		this.haveCloture = false;
		this.alertInputDepreciation = false;
	}

	async $onInit() {
		this.ongletOpen = {
			isEnteteOpen: true,
			isValorisationStocksOpen: true
		};
		this.valorisationStocksFiltres = new ValorisationStocksFiltres();
		await this.getEltsNiv1();
		await this.loadSocietes();

		const $stockSocieteId = this.localStorageService.get('VALO_STOCK_SOCIETE_ID');
		const $stockGrpSiteId = this.localStorageService.get('VALO_STOCK_GRPSITE_ID');

		if (Number($stockSocieteId) && this.societes.length > 0) {
			this.idSociete = Number($stockSocieteId); //Number est obligatoire pour convertir en nombre
			await this.loadRegroupementsSite();
		}

		if (Number($stockGrpSiteId)) {
			this.idRegoupementSite = Number($stockGrpSiteId); //Number est obligatoire pour convertir en nombre
			await this.ChangeRegroupementSite();
		}

		this.$scope.$watch(
			'$ctrl.valorisationStocksFiltres.idDebutPeriode',
			(newValue) => {
				if (newValue !== null) {
					const selectedDebutPeriode = this.debutPeriodes.find((y) => y.idCloturePrecedente === newValue); // on se base sur la date de la periode precedente
					if (!selectedDebutPeriode) {
						return;
					}

					this.finPeriodesDiplay = this.finPeriodes.filter((x) =>
						this.moment(x.date, 'DD/MM/YYYY').isAfter(this.moment(selectedDebutPeriode.date, 'DD/MM/YYYY'))
					);
					this.valorisationStocksFiltres.idFinPeriode = this.finPeriodesDiplay[0]?.idCloture;
					this.changePeriode();
				}
			},
			true
		);

		this.$scope.$watch(
			'$ctrl.valorisationStocksFiltres.idFinPeriode',
			(newValue, oldValue) => {
				if (newValue !== oldValue) {
					this.changePeriode(newValue);
				}
			},
			true
		);
	}

	async loadSocietes() {
		this.startLoading();
		try {
			this.societes = await this.StocksService.getSocietes();
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async loadRegroupementsSite() {
		this.startLoading();
		try {
			if (!this.idSociete) {
				return;
			}
			await this.localStorageService.set('VALO_STOCK_SOCIETE_ID', this.idSociete);
			this.regroupementsSite = await this.StocksService.getRegroupementsSite(this.idSociete);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getEltsNiv1() {
		this.startLoading();
		try {
			this.eltsNiv1 = await this.StocksService.getElementsNiv1();
			if (this.eltsNiv1.length > 0) {
				this.valorisationStocksFiltres.eltNiv1 = this.eltsNiv1[0]?.code;
				await this.getEltsNiv2();
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getEltsNiv2() {
		this.startLoading();
		try {
			if (this.valorisationStocksFiltres.eltNiv1)
				this.eltsNiv2 = await this.StocksService.getElementsNiv2(this.valorisationStocksFiltres.eltNiv1);
			else {
				this.eltsNiv2 = undefined;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getEltsNiv3() {
		this.startLoading();
		try {
			if (this.valorisationStocksFiltres.eltNiv1 && this.valorisationStocksFiltres.eltNiv2)
				this.eltsNiv3 = await this.StocksService.getElementsNiv3(
					this.valorisationStocksFiltres.eltNiv1,
					this.valorisationStocksFiltres.eltNiv2
				);
			else {
				this.eltsNiv3 = undefined;
			}
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async ChangeRegroupementSite() {
		this.initParametres();
		await this.localStorageService.set('VALO_STOCK_GRPSITE_ID', this.idRegoupementSite);
		this.valorisationStocksFiltres.idGrpSite = this.idRegoupementSite;
		if (!this.idRegoupementSite) {
			// await this.resetPeriodes();
			return;
		}
		this.startLoading();
		try {
			this.clotures = await this.StocksService.getPeriodes(this.idRegoupementSite);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
		//si pas de cloture eon propose de cloturer le mois en cours
		if (this.clotures.length === 0) {
			this.haveCloture = false;
			await this.getControls(true);
		} else {
			this.haveCloture = true;

			//fin periodes
			this.finPeriodes = this.getFinPeriodes();

			//debut periodes
			this.debutPeriodes = this.getDebutPeriodes();

			//on set la periode en cours
			this.valorisationStocksFiltres.idDebutPeriode = this.debutPeriodes[0].idCloturePrecedente; //on se base sur la date de la periode precedente
			this.valorisationStocksFiltres.idFinPeriode = this.finPeriodes[0].idCloture;
		}
	}

	getDebutPeriodes() {
		//on calcule la date de début de l'année pour la premiere periode de cloture
		const dateDebutAnnee = this.moment(this.clotures[this.clotures.length - 1].date, 'DD/MM/YYYY')
			.startOf('year')
			.format('DD/MM/YYYY');
		const dateDebutPremierCloture = {
			idCloture: this.clotures[this.clotures.length - 1].idCloture,
			dateCloture: this.clotures[this.clotures.length - 1].date,
			idCloturePrecedente: -1,
			date: dateDebutAnnee,
			estCloture: false
		};
		//cretion des dates de début de période pour les clotures suivantes
		const listeDebutPeriode = this.clotures.map((x) => {
			return {
				idCloture: x.idCloture,
				dateCloture: '',
				idCloturePrecedente: x.idCloture,
				date: this.moment(x.date, 'DD/MM/YYYY').add(1, 'days').format('DD/MM/YYYY'),
				estCloture: false
			};
		});

		//on ajoute l'idCloture de la cloture correspondante a listeDebutPeriode
		listeDebutPeriode.forEach((x) => {
			const indexCloturePrecedente = this.clotures.findIndex((y) => y.idCloture === x.idCloture);
			if (indexCloturePrecedente !== -1) {
				x.idCloture = this.clotures[indexCloturePrecedente - 1] ? this.clotures[indexCloturePrecedente - 1].idCloture : -1;
				x.dateCloture = this.clotures[indexCloturePrecedente - 1] ? this.clotures[indexCloturePrecedente - 1].date : '';
			}
			return x;
		});

		return [...listeDebutPeriode, dateDebutPremierCloture];
	}

	getFinPeriodes() {
		let dateFinNouvelleCloture = null;

		const dernierJourMoisSuivant = this.moment(this.clotures[0].date, 'DD/MM/YYYY').add(1, 'months').endOf('month').format('DD/MM/YYYY');
		const dernierJourDuMoisEncours = this.moment(this.clotures[0].date, 'DD/MM/YYYY').endOf('month').format('DD/MM/YYYY');
		const isDifferentDateDerniereCloture = this.moment(dernierJourDuMoisEncours, 'DD/MM/YYYY').isAfter(
			this.moment(this.clotures[0].date, 'DD/MM/YYYY')
		);
		if (isDifferentDateDerniereCloture) {
			dateFinNouvelleCloture = dernierJourDuMoisEncours;
		} else {
			dateFinNouvelleCloture = dernierJourMoisSuivant;
		}

		return [
			{
				idCloture: -1,
				date: dateFinNouvelleCloture,
				estCloture: false
			},
			...this.clotures
		];
	}

	initParametres() {
		this.valorisationStock = {};
		this.clotures = [];
		this.debutPeriodes = [];
		this.finPeriodesDiplay = [];
		this.libPeriodeCloture = '';
		this.estSaisiePossible = false;
		this.perdiodeIsCloturee = false;
		this.isPeriodePlusieursClotures = false;
		this.datefutureCloture = {};
		this.controls = [];
	}

	changePeriode(idFinPeriodeuu = null) {
		let idFinPeriode = idFinPeriodeuu ? idFinPeriodeuu : this.valorisationStocksFiltres.idFinPeriode;
		let idDebutPeriode = this.valorisationStocksFiltres.idDebutPeriode;
		this.estSaisiePossible = false;
		if (idFinPeriode) {
			this.isPeriodePlusieursClotures = false;
			this.isPeriodePlusieursClotures = idFinPeriode !== this.debutPeriodes.find((x) => x.idCloturePrecedente === idDebutPeriode)?.idCloture;

			if (!this.isPeriodePlusieursClotures) {
				var idxFin = this._.findIndex(this.clotures, { idCloture: idFinPeriode });
				if (idFinPeriode == -1) {
					this.perdiodeIsCloturee = false;
					this.isPeriodePlusieursClotures = false;
				} else {
					this.perdiodeIsCloturee = this.clotures[idxFin]?.estCloture;
					this.isPeriodePlusieursClotures = false;
					this.estSaisiePossible = true;
				}
			}

			if (this.valorisationStock && this.valorisationStock.typeAnalyse > 0) {
				this.alertInputDepreciation = true;
			} else {
				this.alertInputDepreciation = false;
			}
		}
	}

	async loadValorisationStocks() {
		if (this.valorisationStocksFiltres.isValid()) {
			await this.openRefeshMoveModal();
			this.startLoading();

			this.ongletOpen = {
				isEnteteOpen: true,
				isValorisationStocksOpen: true
			};

			this.valorisationStock = {};

			try {
				this.valorisationStock = await this.StocksService.getValorisationStocks(
					this.valorisationStocksFiltres.idGrpSite,
					this.valorisationStocksFiltres.idDebutPeriode,
					this.valorisationStocksFiltres.idFinPeriode,
					this.valorisationStocksFiltres.eltNiv1,
					this.valorisationStocksFiltres.eltNiv2,
					this.valorisationStocksFiltres.eltNiv3,
					this.typeAnalyseDemande
				);
			} catch (ex) {
				this.notification.error(ex.data);
			} finally {
				this.stopLoading();
			}
		} else {
			this.$scope.$broadcast('valorisationStocksFiltresValidations');
		}
		this.alertInputDepreciation = false;
	}

	startLoading() {
		this.loading = true;
	}

	stopLoading() {
		this.loading = false;
	}

	openDepreciationQte(valorisationStockLigne) {
		var _this = this;
		_this.source = valorisationStockLigne;
		this.$uibModal
			.open({
				template: '<depreciation-stock-qte ligne="$ctrl.source" modal-instance="$ctrl.uibModalInstance"></depreciation-stock-qte>',
				controller: [
					'$uibModalInstance',
					function ($uibModalInstance) {
						var $ctrl = this;
						$ctrl.source = _this.source;
						$ctrl.uibModalInstance = $uibModalInstance;
					}
				],
				controllerAs: '$ctrl',
				size: 'xxl',
				backdrop: false
			})
			.result.then(async function (result) {
				if (result) {
					_this.startLoading();
					try {
						await _this.StocksService.sauveDepreciation(
							true,
							_this.valorisationStocksFiltres.idGrpSite,
							_this.valorisationStocksFiltres.idFinPeriode,
							valorisationStockLigne.idProduit,
							valorisationStockLigne.idSiteProducteur,
							valorisationStockLigne.idEmplacement,
							valorisationStockLigne.idMotifFinalQte,
							valorisationStockLigne.stockFinalQuantiteDepreciee,
							undefined
						);
					} catch (ex) {
						_this.notification.error(ex.data);
					} finally {
						_this.stopLoading();
					}
					_this.loadValorisationStocks();
				}
			});
	}

	openDepreciationPrix(valorisationStockLigne) {
		var _this = this;
		_this.source = valorisationStockLigne;
		this.$uibModal
			.open({
				template: '<depreciation-stock-prix ligne="$ctrl.source" modal-instance="$ctrl.uibModalInstance"></depreciation-stock-prix>',
				controller: [
					'$uibModalInstance',
					function ($uibModalInstance) {
						var $ctrl = this;
						$ctrl.source = _this.source;
						$ctrl.uibModalInstance = $uibModalInstance;
					}
				],
				controllerAs: '$ctrl',
				size: 'xxl',
				backdrop: false
			})
			.result.then(async function (result) {
				if (result) {
					+this.startLoading();
					try {
						await this.StocksService.sauveDepreciation(
							false,
							this.valorisationStocksFiltres.idGrpSite,
							this.valorisationStocksFiltres.idFinPeriode,
							valorisationStockLigne.idProduit,
							valorisationStockLigne.idSiteProducteur,
							valorisationStockLigne.idEmplacement,
							valorisationStockLigne.idMotifFinalPrix,
							undefined,
							valorisationStockLigne.stockFinalPrixDeprecie
						);
					} catch (ex) {
						this.notification.error(ex.data);
					} finally {
						this.stopLoading();
					}
					this.loadValorisationStocks();
				}
			});
	}

	async print() {
		this.startLoading();
		var fileName = Date.now();

		let resultat = await this.StocksService.printValorisationStock(
			this.valorisationStocksFiltres.idGrpSite,
			this.valorisationStocksFiltres.idDebutPeriode,
			this.valorisationStocksFiltres.idFinPeriode,
			this.valorisationStocksFiltres.eltNiv1,
			this.valorisationStocksFiltres.eltNiv2,
			this.valorisationStocksFiltres.eltNiv3,
			this.typeAnalyseDemande
		);

		let data = resultat.data;
		let headers = resultat.headers;

		headers = headers();

		var contentType = headers['content-type'];

		let fileExtention = '.xlsx';
		var linkElement = document.createElement('a');
		try {
			var blob = new Blob([data], { type: contentType + ';charset=UTF-8' });
			var url = window.URL.createObjectURL(blob);
			linkElement.setAttribute('href', url);
			linkElement.setAttribute('download', fileName + fileExtention);

			var clickEvent = new MouseEvent('click', {
				view: window,
				bubbles: true,
				cancelable: false
			});
			linkElement.dispatchEvent(clickEvent);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}
	}

	async getControls(toCloture = false) {
		if (!this.haveCloture && toCloture) {
			let isOKNoClotureTocloture = false;
			this.haveCloture = this.clotures.length > 0;

			let modalInstance = null;
			if (this.haveCloture) {
				modalInstance = await this.ModalService.confirm({
					modalTitle: 'Clôturer le mois',
					modalMsg: this.$translate.instant('STOCKS.CONTROLS.CLOTURER_MOIS'),
					headerClass: 'modal-info'
				});
			} else {
				modalInstance = await this.ModalService.open({
					component: 'ModalPremiereCloture',
					animation: true,
					size: 'l',
					backdrop: false,
					resolve: {}
				});
			}

			isOKNoClotureTocloture = await modalInstance.result.then(
				(data) => {
					this.dateDebutClotureChoosed = data;
					return true;
				},
				() => {
					return false;
				}
			);
			if (!isOKNoClotureTocloture) {
				return;
			}
		}

		let controls = null;
		this.startLoading();
		try {
			controls = await this.StocksService.getControls(this.valorisationStocksFiltres.idGrpSite);
		} catch (ex) {
			this.notification.error(ex.data);
		} finally {
			this.stopLoading();
		}

		if (controls !== null) {
			if (controls.cloturesCount > 0) {
				const _this = this;
				_this.controls = controls;
				_this.toCloture = toCloture;

				const modalInstance = _this.$uibModal.open({
					animation: true,
					size: 'md',
					backdrop: true,
					windowClass: 'modern-modal',
					template: `
                        <div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
                            <div class="mas-col-fit">
                                <button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
                                    <span style="color: white" aria-hidden="true">&times;</span>
                                </button>
                                <h4 class="modal-title"><span translate="STOCKS.CONTROLS.TITLE_MODAL"></span></h4>
                            </div>
                        </div>
                        <div class="modal-body" ng-init="voirPlus = false">
                            <span translate="STOCKS.CONTROLS.PERIODE_TO_CLOTURE"></span><span>  : {{$ctrl.dateDebutCloture}} au {{$ctrl.dateFinCloture}}</span><br>
                            <div ng-if="$ctrl.haveAlert" class="alert alert-warning" role="alert">
                                <span class="glyphicon glyphicon-warning-sign" style="color:orange"></span>&nbsp;
                                <span ng-if="$ctrl.controls.isTooLargePeriod" translate="STOCKS.CONTROLS.TOO_LARGE_PERIOD"></span>
                                <span ng-if="$ctrl.controls.isNotGoodState" translate="STOCKS.CONTROLS.NOT_GOOD_STATE"></span>
                                <span ng-if="$ctrl.controls.ticketsCount === 0" translate="STOCKS.CONTROLS.NO_TICKET"></span>
							</div>
							<button ng-show="$ctrl.controls.isNotGoodState" class="btn btn-xs btn-primary" type="button" ng-click="voirPlus = !voirPlus">
								<span translate="STOCKS.CONTROLS.VOIR_PLUS"></span>
							</button>
							<div ng-if="voirPlus == 1" class="mas-p-5">
								<div style="display: block; width: 100%; height: 300px; overflow-y: auto; overflow-x: hidden;">
									<span class="bold">{{$ctrl.ticketEtatDefaultAchat.length}}</span> <spann class="bold" translate="STOCKS.CONTROLS.TICKET_ACHAT"></spann><br>
									<ul ng-repeat="ticket in $ctrl.ticketEtatDefaultAchat">
										<li>{{ticket.message}}</li>
									</ul>
									<span class="bold">{{$ctrl.ticketEtatDefaultVente.length}}</span> <spann class="bold" translate="STOCKS.CONTROLS.TICKET_VENTE"></spann><br>
									<ul ng-repeat="ticket in $ctrl.ticketEtatDefaultVente">
										<li>{{ticket.message}}</li>
									</ul>
								</div>
							</div>							
                            <div ng-if="!$ctrl.haveAlert" class="alert alert-success" role="alert">
                                <span class="glyphicon glyphicon-ok-sign"></span>&nbsp;<span translate="STOCKS.CONTROLS.OK_FOR_CLOTURE_PERIODE"></span>
                            </div><br>
                            <span ng-if="$ctrl.toCloture && !$ctrl.controls.isTooLargePeriod" translate="STOCKS.CONTROLS.ARE_YOU_SURE"></span>
                        </div>
                        <div class="modal-footer">
                            <div class="mas-col-fit">
                                <div class="mas-row mas-jc-fend">
                                    <div class="mas-col-fit">
                                        <button ng-if="$ctrl.toCloture" class="btn btn-primary" type="button" ng-click="$ctrl.cloturer()">
                                            <span translate="STOCKS.CLOTURER"></span>
                                        </button>
                                        <button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
                                            <span class="massia-icon-door_exit"></span>
                                            <span class="hidden-xs" translate="FERMER"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        `,
					controllerAs: '$ctrl',
					controller: [
						'$uibModalInstance',
						function ($uibModalInstance) {
							this.controls = _this.controls;
							const {
								isNotGoodState,
								isTooLargePeriod,
								ticketsCount,
								ticketEtatDefaultAchat = [],
								ticketEtatDefaultVente = []
							} = _this.controls;
							this.haveAlert = isNotGoodState || isTooLargePeriod || ticketsCount === 0;
							this.ticketEtatDefaultAchat = ticketEtatDefaultAchat;
							this.ticketEtatDefaultVente = ticketEtatDefaultVente;

							this.dateDebutCloture = _this.debutPeriodes[0].date;
							this.dateFinCloture = _this.finPeriodes[0].date;
							this.toCloture = _this.toCloture;
							this.close = () => $uibModalInstance.dismiss('cancel');
							this.cloturer = () => {
								$uibModalInstance.close();
							};
						}
					]
				});
				modalInstance.result.then(async function () {
					await _this.cloturer();
				});
			} else {
				if (toCloture) {
					this.cloturer();
				}
			}
		}
	}

	async cloturer() {
		this.startLoading();
		try {
			const date = this.haveCloture
				? this.finPeriodes.find((x) => x.idCloture === this.valorisationStocksFiltres.idFinPeriode)?.date
				: this.dateDebutClotureChoosed;

			await this.StocksCloturesService.getFormulesExpirees(this.valorisationStocksFiltres.idGrpSite, date, true);
			//L'exécution peut être bloquée par la modale de 'getFormulesExpirees'
			await this.StocksService.clotureMensuelle(
				this.valorisationStocksFiltres.idGrpSite,
				date,
				null,
				this.haveCloture ? this.valorisationStocksFiltres.idFinPeriode : -1
			);
			this.notification.success('STOCKS.CLOTURE_SUCCESS');
			//reload periodes et valorisation
			await this.ChangeRegroupementSite();
			this.changePeriode();
		} catch (ex) {
			this.ModalService.info({ modalTitle: 'Clôture impossible', modalMsg: ex.data, headerClass: 'modal-info' });
			return false;
		} finally {
			this.stopLoading();
		}
	}

	async decloturer() {
		if (this.perdiodeIsCloturee) {
			const modalInstance = await this.ModalService.confirm({
				modalTitle: 'Décloturer le mois',
				modalMsg: this.$translate.instant('STOCKS.DECLOTURER_MOIS'),
				headerClass: 'modal-info'
			});

			modalInstance.result.then(async () => {
				this.startLoading();
				try {
					const date = this.finPeriodes.find((x) => x.idCloture === this.valorisationStocksFiltres.idFinPeriode)?.date;
					if (this.valorisationStocksFiltres.idGrpSite && date) {
						await this.StocksService.decloturerMois(this.valorisationStocksFiltres.idGrpSite, date);
						this.notification.success('STOCKS_CLOTURES.DECLOTURE_MOIS_EFFECTUEE');
					}
					await this.ChangeRegroupementSite();
					this.changePeriode();
				} catch (ex) {
					this.notification.error(ex.data);
				} finally {
					this.stopLoading();
				}
			});
		}
	}

	async openRefeshMoveModal() {
		var _this = this;

		var latestClosure = await _this.StocksService.getDerniereCloture(_this.idRegoupementSite);
		if (!latestClosure.haveClotureJour) return;
		return await _this.$uibModal
			.open({
				template: `
					<div class="modal-header modal-info mas-column mas-p-10" style="gap: 5px">
						<div class="mas-col-fit">
							<button type="button" class="close" aria-label="Close" ng-click="$ctrl.close()">
								<span style="color: white" aria-hidden="true">&times;</span>
							</button>
							<h4 class="modal-title"><span translate="STOCKS.CONTROLS.TITLE_MODAL_LAST_ACTUALISATION"></span></h4>
						</div>
					</div>
					<div class="modal-body" ng-init="voirPlus = false">		
						<div>
							<span ng-if="$ctrl.isBefore">La dernière actualisation des mouvements a été effectuée il y a {{$ctrl.data.tempsDepuis}} : le {{$ctrl.data.date}} à {{$ctrl.data.heure}}.</span><br>
							<span>Souhaitez-vous actualiser les mouvements maintenant ?</span><br>
						</div>
					</div>
					<div class="modal-footer">
						<div class="mas-col-fit">
							<div class="mas-row mas-jc-fend">
								<div class="mas-col-fit">
									<button class="btn btn-primary" type="button" ng-click="$ctrl.actualiser()">
										<span class="glyphicon glyphicon-ok-sign"></span>
										<span translate="OUI"></span>
									</button>
									<button class="btn btn-primary" type="button" ng-click="$ctrl.close()">
										<span class="glyphicon glyphicon-remove"></span>
										<span class="hidden-xs" translate="NON"></span>
									</button>
								</div>
							</div>
						</div>
					</div>					
					`,
				controller: [
					'$uibModalInstance',
					function ($uibModalInstance) {
						var $ctrl = this;
						$ctrl.data = latestClosure;
						$ctrl.isBefore = _this.moment(latestClosure.date, 'DD/MM/YYYY').isBefore(_this.moment());
						$ctrl.uibModalInstance = $uibModalInstance;
						$ctrl.close = () => {
							$uibModalInstance.close(false);
						};
						$ctrl.actualiser = () => {
							$uibModalInstance.close(true);
						};
					}
				],
				controllerAs: '$ctrl',
				size: 'lg',
				backdrop: false
			})
			.result.then(async function (isActualiser) {
				if (isActualiser) {
					_this.startLoading();
					var res = await _this.StocksService.refreshMouvements(_this.idRegoupementSite);
					if (res) {
						_this.stopLoading();
					}
				}
			});
	}
}
